import { isRN, isIOS, appVersion } from '@src/lib/env_detect';
// Development environment or test/release environment
// So the two need to be combined
export var ENVIROMENT = process.env.NODE_ENV === 'production' ? 'PROD' : 'DEV';
export var isProd = ENVIROMENT === 'PROD';
// Platform (iOS, Android, Web)]
export var PLATFORM_VERSION = isRN ? (isIOS ? 'IOS' : 'ANDROID') : 'WEB';
// @TODO，if you don't need ENV, you can remove ENVIROMENT in the following array
export var SENTRY_RELEASE_LABEL = [ENVIROMENT, PLATFORM_VERSION, appVersion].join('_');
export var LOG_LEVEL = {
    P0: 'fatal',
    P1: 'error',
    P2: 'warning',
    P3: 'info',
    P4: 'debug',
    P5: 'critical',
};
export var MONITORY_TYPE = {
    GLOBAL_EXCEPTION: {
        level: LOG_LEVEL.P1,
        type: 'GLOBAL ERROR',
    },
    TIME_OUT: {
        level: LOG_LEVEL.P0,
        type: 'REQUEST TIMEOUT',
    },
};
